<div class="lum-c-report-stock-snapshot-ag-table">
  <div
    class="overlay"
    lumAppLoader
    [loading]="(loading$ | async) || false"
    [classes]="'loading blur'"
  ></div>
  <ag-grid-angular
    class="
      ag-theme-alpine ag-theme-lum ag-theme-lum--next lum-c-report-stock-snapshot-ag-table__table
    "
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (columnMoved)="onColumnMoved($event)"
    (filterChanged)="onFilterChanged()"
  ></ag-grid-angular>

  <div class="lum-paging lum-page__ag-grid__paging">
    <div class="lum-paging__jump-to-page">
      <label class="lum-label my-2">Page</label>
      <input
        #pageInput
        class="lum-paging__jump-to-page-input"
        type="number"
        [min]="1"
        [max]="pagination.last_page"
        [disabled]="pagination.total === 0"
        [value]="pagination.current_page || 1"
        (input)="handleGoToPageInput(pageInput)"
        (keyup.enter)="gotoPage(pageInput.value)"
        lumInvalidNumberInput
        lumFocusHighlight
      />
      <label class="lum-label my-2">of {{ pagination.last_page }}</label>
    </div>
    <mat-paginator
      [length]="pagination.total || 0"
      [pageSize]="pagination.per_page"
      [pageSizeOptions]="paginationConfig.pageSizeOptions"
      [pageIndex]="(pagination.current_page || 1) - 1"
      (page)="onPaginationEvent($event)"
      aria-label="Select page"
    ></mat-paginator>
  </div>
</div>
